import { z } from "zod";

export const shipmentDetailSchema = z.object({
	poNumber: z.number(),
	customerId: z.number(),
	rateType: z.string().nullable(),
	loadStatus: z.string().nullable(),
	loadDate: z.string().nullable(),
	pickupApptDateTime: z.string().nullable(),
	actualPickupDateTime: z.string().nullable(),
	deliveryApptDateTime: z.string().nullable(),
	actualDeliveryDateTime: z.string().nullable(),
	numberOfStops: z.number().nullable(),
	customerPO: z.string().nullable(),
	originName: z.string().nullable(),
	originCity: z.string().nullable(),
	originStateProvinceCode: z.string().nullable(),
	originPostalCode: z.string().nullable(),
	originCountryCode: z.string().nullable(),
	destinationName: z.string().nullable(),
	destinationCity: z.string().nullable(),
	destinationStateProvinceCode: z.string().nullable(),
	destinationPostalCode: z.string().nullable(),
	destinationCountryCode: z.string().nullable(),
	trailerType: z.string().nullable(),
	trailerSize: z.string().nullable(),
	loadWeight: z.number().nullable(),
	handlingUnits: z.string().nullable(),
	primaryCommodity: z.string().nullable(),
	class: z.string().nullable(),
	practicalMiles: z.number().nullable(),
	totalBillAmount: z.number().nullable().optional(),
	assessorialAmount: z.number().nullable(),
	quantity: z.number().nullable(),
	etlDate: z.string().nullable(),
	checksumColumn: z.string().nullish(),
	palletCount: z.number().nullable(),
	caseCount: z.number().nullable(),
	lane: z.string().nullable(),
	proNumber: z.string().nullable(),
	soNumber: z.string().nullable(),
	containerNumber: z.string().nullable(),

	pickupCount: z.number().nullish(),
	dropCount: z.number().nullish(),
	paidDate: z.string().nullish(),
	fuelSurcharge: z.number().nullish(),
	detention: z.number().nullish(),
	layover: z.number().nullish(),
	tonu: z.number().nullish(),
	originalAmount: z.number().nullish(),
	currentAmount: z.number().nullish(),
	cdcCapTimestamp: z.string().nullish(),
	cdcOpVal: z.number().nullish(),
	kafkaConsumerGroup: z.string().nullish(),
	kafkaTopicPartition: z.number().nullish(),
	kafkaTopicOffset: z.number().nullish(),
	kafkaTimeStampUtc: z.string().nullish(),
});

export const shipmentDetailListSchema = z.array(shipmentDetailSchema);

export type ShipmentDetail = z.infer<typeof shipmentDetailSchema>;
